import { type FC, type PropsWithChildren } from 'react';
import { type Locales, TonConnectUIProvider } from '@tonconnect/ui-react';

import { ENV } from '@/common/app/env';
import { useAppSelector } from '@/redux/store';

const TonConnectProvider: FC<PropsWithChildren> = ({ children }) => {
  const language = useAppSelector((state) => state.user.user?.language);

  return (
    <TonConnectUIProvider
      language={language as Locales | undefined}
      manifestUrl={ENV.TONCONNECT_MANIFEST_URL}
      actionsConfiguration={{
        twaReturnUrl: `https://t.me/${ENV.TELEGRAM_BOT_NAME}`,
      }}
    >
      {children}
    </TonConnectUIProvider>
  );
};

export { TonConnectProvider };
